
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"30","height":"30","rx":"15","fill":"#E2E2E2"}}),_c('g',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#333"}},[_c('path',{attrs:{"d":"M22.257 15a.59.59 0 01-.589.59H15.59l.001 6.078a.59.59 0 11-1.178 0l-.001-6.078H8.336a.59.59 0 110-1.178h6.075l-.001-6.076a.59.59 0 011.178 0l.001 6.076h6.08a.59.59 0 01.588.589z"}}),_c('path',{attrs:{"d":"M21.668 14.307a.694.694 0 010 1.387h-5.974v5.974a.693.693 0 11-1.387 0v-5.973h-5.97a.694.694 0 01-.001-1.387h5.97V8.335a.693.693 0 111.387 0v5.971h5.975zm.485.694a.485.485 0 00-.485-.485h-6.183v-6.18a.485.485 0 10-.971 0v6.18H8.337a.485.485 0 100 .97h6.179v6.182a.485.485 0 10.971 0v-6.182h6.182a.485.485 0 00.485-.485z"}})])])
          )
        }
      }
    